import { useLogout } from '@/api/auth/logout';
import { useMe } from '@/api/user/use-me';
import { colorVar } from '@/utils/colors';
import { getTokens } from '@/utils/cookies';
import { ActionIcon, Menu, rem, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { BookMarked, CircleUser, LogOut, Settings, User } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ProfileModal } from '../profile/ProfileModal';

export default function UserMenu() {
  const { mutate: logout } = useLogout();
  const { data: user, isLoading } = useMe();

  const [profileOpened, { open: openProfile, close: closeProfile }] =
    useDisclosure(false);

  const handleLogout = () => {
    const tokens = getTokens();
    if (tokens?.refreshToken) {
      logout(tokens.refreshToken);
    }
  };

  return (
    <>
      <ProfileModal opened={profileOpened} onClose={closeProfile} />

      <Menu shadow="md" width={'auto'} position="bottom-end" radius={'sm'}>
        <Menu.Target>
          <ActionIcon
            variant="transparent"
            color="brand-grey-4"
            size="lg"
            radius="xl"
          >
            <CircleUser size={24} />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown>
          {!isLoading ? (
            <Menu.Label
              component="div"
              mb={'4px'}
              style={{
                borderBottom:
                  '1px solid var(--mantine-color-brand-border-grey-1)',
              }}
            >
              <Text variant="semibold16">{user?.name}</Text>
              <Text variant="regular14">{user?.email}</Text>
            </Menu.Label>
          ) : (
            <></>
          )}
          <Menu.Item
            leftSection={<User style={{ width: rem(14), height: rem(14) }} />}
            onClick={openProfile}
          >
            <Text variant="regular14">Profile</Text>
          </Menu.Item>
          <Menu.Item
            component={Link}
            to="/user-management"
            leftSection={
              <Settings
                color={colorVar('brand-black')}
                style={{ width: rem(14), height: rem(14) }}
              />
            }
          >
            <Text variant="regular14">User Management</Text>
          </Menu.Item>

          <Menu.Item
            component={Link}
            to="/user-guides"
            leftSection={
              <BookMarked
                color={colorVar('brand-black')}
                style={{ width: rem(14), height: rem(14) }}
              />
            }
          >
            <Text variant="regular14">User Guides</Text>
          </Menu.Item>

          <Menu.Item
            leftSection={
              <LogOut
                color={colorVar('brand-black')}
                style={{ width: rem(14), height: rem(14) }}
              />
            }
            onClick={handleLogout}
          >
            <Text variant="regular14">Logout</Text>
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </>
  );
}
